import type { SVGProps } from "react";

export default function CirclePlusIcon(
  props: SVGProps<SVGSVGElement>,
  active?: boolean,
  className?: string,
) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
        strokeWidth="1.25"
        {...(active ? { stroke: "#F5A800" } : { stroke: "currentColor" })}
      />
      <path
        d="M14.9995 12H11.9995M11.9995 12H8.99951M11.9995 12V9M11.9995 12V15"
        strokeWidth="1.25"
        strokeLinecap="round"
        {...(active ? { stroke: "#F5A800" } : { stroke: "currentColor" })}
      />
    </svg>
  );
}
